import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import "./WelcomeModal.scss";

function WelcomeModal() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  const handleClose = () => {
    setShow(false);
    localStorage.setItem("confessit.welcome", true);
  };

  useEffect(() => {
    const hasSeenWelcome = localStorage.getItem("confessit.welcome");
    if (!hasSeenWelcome) {
      setShow(true);
    }
  }, []);

  return (
    <Modal show={show} onHide={handleClose} centered contentClassName="welcome-modal-content">
      <Modal.Body className="welcome-modal-body">
        <div className="welcome-icon">⛪</div>
        <h2 className="welcome-title">{t("welcome_simple.title")}</h2>
        <p className="welcome-subtitle">{t("welcome_simple.subtitle")}</p>

        <div className="welcome-steps">
          <div className="welcome-step">
            <div className="step-icon">
              <i className="fa fa-list-ul"></i>
            </div>
            <div className="step-content">
              <span className="step-number">1</span>
              <span className="step-text">{t("welcome_simple.step_1")}</span>
            </div>
          </div>
          <div className="welcome-step">
            <div className="step-icon">
              <i className="fa fa-check"></i>
            </div>
            <div className="step-content">
              <span className="step-number">2</span>
              <span className="step-text">{t("welcome_simple.step_2")}</span>
            </div>
          </div>
          <div className="welcome-step">
            <div className="step-icon">
              <i className="fa fa-book"></i>
            </div>
            <div className="step-content">
              <span className="step-number">3</span>
              <span className="step-text">{t("welcome_simple.step_3")}</span>
            </div>
          </div>
        </div>

        <div className="welcome-features">
          <h4 className="features-title">{t("welcome_simple.features_title")}</h4>

          <div className="feature-card">
            <div className="feature-icon">✝️</div>
            <div className="feature-content">
              <h5>{t("welcome_simple.feature_saints.title")}</h5>
              <p>{t("welcome_simple.feature_saints.description")}</p>
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-icon">📿</div>
            <div className="feature-content">
              <h5>{t("welcome_simple.feature_rosary.title")}</h5>
              <p>{t("welcome_simple.feature_rosary.description")}</p>
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-icon">❤️</div>
            <div className="feature-content">
              <h5>{t("welcome_simple.feature_coronilla.title")}</h5>
              <p>{t("welcome_simple.feature_coronilla.description")}</p>
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🙏</div>
            <div className="feature-content">
              <h5>{t("welcome_simple.feature_litany.title")}</h5>
              <p>{t("welcome_simple.feature_litany.description")}</p>
            </div>
          </div>
        </div>

        <div className="welcome-privacy">
          <i className="fa fa-shield"></i>
          <span>{t("welcome_simple.privacy")}</span>
        </div>

        <Button variant="primary" className="welcome-button" onClick={handleClose}>
          {t("welcome_simple.start")}
          <i className="fa fa-arrow-right ms-2"></i>
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default WelcomeModal;
